import Box from '@mui/material/Box';
import useEmailSettings from './hooks/email-settings.hooks';
import { CustomerDetail } from '../../../../features/users/views/CustomerDetailsTable';
import StandardButton from '../../../components/Button/StandardButton';
import ClearIcon from '@mui/icons-material/Clear';
import { useMemo } from 'react';

type ResetEmailSettingsProps = {
    data: CustomerDetail;
    onUpdate: (data: CustomerDetail) => void;
};

const ResetEmailSettings = ({ data, onUpdate }: ResetEmailSettingsProps) => {
    const { clearEmailSettings } = useEmailSettings();

    const handleSendEmailTest = async () => {
        try {
            await clearEmailSettings(data);

            onUpdate({
                ...data,
                smtpOutgoingHost: '',
                smtpOutgoingPort: '',
                smtpPassword: '',
                emailAddress: '',
                emailType: 'NONE',
                emailUserAccount: '',
            });

            alert('Email settings cleared');
        } catch {
            alert('Failed to clear email settings');
        }
    };

    return (
        <Box>
            <StandardButton onClick={handleSendEmailTest} icon={<ClearIcon />} fullWidth>
                Reset Email Settings
            </StandardButton>
        </Box>
    );
};

export default ResetEmailSettings;
